export default "__VITE_ASSET__B148uAWK__"